import { includes } from '@nk/utils-lib';

// These colors are defined in highcharts_styles.scss
enum ColorClassNamesCreditors {
  aprila_bank_black = 'aprilabank-black', // note spacing difference.. todo: fix.
  bank_norwegian_red = 'banknorwegian-red',
  bn_bank_red = 'bnbank-red',
  danske_bank_blue = 'danskebank-blue',
  dnb_green = 'dnb-green',
  eika_green = 'eika-green',
  gjensidige_blue = 'gjensidige-blue',
  handelsbanken_blue = 'handelsbanken-blue',
  husbanken_green = 'husbanken-green',
  naeringsbanken_black = 'naeringsbanken-black',
  nordea_blue = 'nordea-blue',
  ncb_black = 'ncb-black',
  obos_blue = 'obos-blue',
  santander_red = 'santander-red',
  sparebank1_blue = 'sparebank1-blue',
  sbanken_blue = 'sbanken-blue',
  sparebanken_vest_red = 'sparebankenvest-red',
  jaeren_sparebank_black = 'jaerensparebank-black',
  sparebanken_more_blue = 'sparebankenmore-blue',
  sparebanken_sor_orange = 'sparebankensor-orange',
  romerike_sparebank_green = 'romerikesparebank-green',
  other = 'other',
}

const CREDITOR_NAME_TO_COLOR_CLASS: { name: string; colorClass: string | undefined }[] = [
  { name: 'APRILA BANK ASA', colorClass: ColorClassNamesCreditors.aprila_bank_black },
  {
    name: 'BANK NORWEGIAN, EN FILIAL AV NORDAX BANK AB (PUBL)',
    colorClass: ColorClassNamesCreditors.bank_norwegian_red,
  },
  { name: 'BANK2 ASA', colorClass: undefined },
  { name: 'BANKENES BOLIGMEGLER AS', colorClass: undefined },
  { name: 'BANKIER JOHS G HEFTYES LEGAT', colorClass: undefined },
  { name: 'BB BANK ASA', colorClass: undefined },
  { name: 'BN BANK ASA', colorClass: ColorClassNamesCreditors.bn_bank_red },
  { name: 'BOLIGBANKEN ASA', colorClass: undefined },
  { name: 'COLLECTOR BANK AB, NORGE FILIAL', colorClass: undefined },
  { name: 'DANSKE BANK', colorClass: ColorClassNamesCreditors.danske_bank_blue },
  { name: 'DEN NORSKE BANKS FOND TIL NORGES HANDELSHØYSKOLE', colorClass: undefined },
  { name: 'DNB BANK ASA', colorClass: ColorClassNamesCreditors.dnb_green },
  { name: 'DVB BANK SE NORDIC BRANCH', colorClass: undefined },
  { name: 'EIKA KREDITTBANK AS', colorClass: ColorClassNamesCreditors.eika_green },
  { name: 'GJENSIDIGE BANK HOLDING AS', colorClass: ColorClassNamesCreditors.gjensidige_blue },
  { name: 'HANDELSBANKEN', colorClass: ColorClassNamesCreditors.handelsbanken_blue },
  { name: 'HANDELSBANKEN', colorClass: ColorClassNamesCreditors.handelsbanken_blue }, // NOTE: why 2?
  {
    name: 'HANDELSBANKEN EIENDOMSKREDITT FILIAL AV STADSHYPOTEK AB',
    colorClass: ColorClassNamesCreditors.handelsbanken_blue,
  },
  { name: 'HUSBANKEN', colorClass: ColorClassNamesCreditors.husbanken_green },
  { name: 'INSTABANK ASA', colorClass: undefined },
  { name: 'JYSKE BANK AS', colorClass: undefined },
  { name: 'KRAFT BANK ASA', colorClass: undefined },
  { name: 'LANDKREDITT BANK AS', colorClass: undefined },
  { name: 'LEA BANK ASA', colorClass: undefined },
  { name: 'MARITIME & MERCHANT BANK ASA', colorClass: undefined },
  { name: 'MORROW BANK ASA', colorClass: undefined },
  { name: 'MYBANK ASA', colorClass: undefined },
  { name: 'NÆRINGSBANKEN ASA', colorClass: ColorClassNamesCreditors.naeringsbanken_black },
  { name: 'NORDEA BANK NORGE ASA', colorClass: ColorClassNamesCreditors.nordea_blue },
  { name: 'NORDEA DIRECT BANK ASA', colorClass: ColorClassNamesCreditors.nordea_blue },
  { name: 'NORDIC CORPORATE BANK ASA', colorClass: ColorClassNamesCreditors.ncb_black },
  { name: 'NORDNET BANK', colorClass: undefined },
  { name: 'NORGES BANK', colorClass: undefined },
  { name: 'OBOS-BANKEN AS', colorClass: ColorClassNamesCreditors.obos_blue },
  { name: 'OPTIN BANK ASA, UNDER OFFENTLIG ADMINISTRASJON', colorClass: undefined },
  { name: 'PARETO BANK ASA', colorClass: undefined },
  { name: 'ROMSDALS FELLESBANK ASA', colorClass: undefined },
  { name: 'SANTANDER CONSUMER BANK AS', colorClass: 'santander-red' },
  {
    name: 'SANTANDER CONSUMER BANK, FILIAL AV SANTANDER CONSUMER BANK, SVERIGE',
    colorClass: ColorClassNamesCreditors.santander_red,
  },
  { name: 'SBANKEN ASA', colorClass: ColorClassNamesCreditors.sbanken_blue },
  { name: 'SEB PRIVATBANKEN ASA', colorClass: undefined },
  { name: 'SKANDIABANKEN AB Norsk avdeling av utenlandsk foretak', colorClass: undefined },
  { name: 'SPARESKILLINGSBANKEN', colorClass: undefined },
  { name: 'STIFTELSEN FOR ANSATTE I NORGES KOMMUNALBANK', colorClass: undefined },
  { name: 'STOREBRAND BANK ASA', colorClass: undefined },
  { name: 'SWEDBANK NORGE', colorClass: undefined },
  { name: 'TOYOTA KREDITBANK GMBH norsk avdeling av utenlandsk foretak', colorClass: undefined },
  { name: 'SPAREBANKEN VEST', colorClass: ColorClassNamesCreditors.sparebanken_vest_red },
  { name: 'JÆREN SPAREBANK', colorClass: ColorClassNamesCreditors.jaeren_sparebank_black },
  { name: 'SPAREBANKEN MØRE', colorClass: ColorClassNamesCreditors.sparebanken_more_blue },
  { name: 'SPAREBANKEN SØR', colorClass: ColorClassNamesCreditors.sparebanken_sor_orange },
  { name: 'ROMERIKE SPAREBANK', colorClass: ColorClassNamesCreditors.romerike_sparebank_green },
  { name: 'Other', colorClass: ColorClassNamesCreditors.other },
];

export function getColorClass(creditorName: string): string | undefined {
  if (includes(creditorName, 'SPAREBANK1')) {
    return ColorClassNamesCreditors.sparebank1_blue;
  }
  const colorClass = CREDITOR_NAME_TO_COLOR_CLASS.find((a) => a.name == creditorName);
  if (colorClass) {
    return colorClass.colorClass;
  }
  return undefined;
}
